var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_start mb-16"},[_vm._m(0),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_start title-icon mr-12"},[_c('div',{staticStyle:{"height":"6px","background":"#0f3b99"}}),_c('div',{staticStyle:{"height":"10px","background":"#fe3f3e"}})])
}]

export { render, staticRenderFns }